import { useQuery } from '@tanstack/vue-query'
import { computed, MaybeRef, toValue } from 'vue'
import { hcaClientFactory } from '@/api/factories/HcaClientFactory'
import { whenAuthenticatedAnd } from '@/utils/query-utils'
import { ComponentType } from '@/configuration/component/component-types'

export const useComponentStatusQuery = (componentId: MaybeRef<string | undefined>, componentType: MaybeRef<ComponentType | undefined>) => {
    return useQuery({
        queryKey: ['componentStatus', componentId, componentType],
        queryFn: async ({ signal }) => {
            const {
                data: { result },
            } = await hcaClientFactory.componentStatusApi.getConditionStatusByComponent(toValue(componentId as string), toValue(componentType as ComponentType), {
                signal,
            })
            return result
        },
        enabled: whenAuthenticatedAnd(computed(() => !!toValue(componentId))),
    })
}
